import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import socket from './modules/socket'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    auth,
    socket
  },
  strict: debug
})